import { ElementType } from './pageElements';

export const ALLOWED_NESTING = [ElementType.HTMLText, ElementType.Figure];
